module.exports = __webpack_public_path__ + "img/app-engine-kill.6afb9dec.svg";